import HolifyaLogoComplete from '@/components/HolifyaLogoComplete';
import { Button } from '@/components/ui/button';
import { useCreateEvent } from '@/features/events/hooks/useCreateEvent';
import { EventType } from '@/features/events/types/EventType';
import { LoadingOverlay } from '@/features/shared/components/Loaders';
import { WarningDialog } from '@/pages/new-platform/components/WarningDialog';
import { useAuthStore } from '@/utils/stores/useAuthStore';
import { useUserStore } from '@/utils/stores/useUserStore';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SortingItemCard } from '../components/SortingItemCard';
import { useSortingButton } from '../hooks/useSortingButton';
import { useSortingItems } from '../hooks/useSortingItems';

export const Sorting = () => {
    const navigate = useNavigate();
    const { sendEvent } = useCreateEvent();
    const { auth } = useAuthStore();
    const { userData } = useUserStore();
    const {
        sortingItems,
        selectedItems,
        setSelectedItems,
        warningMessage,
        setWarningMessage,
        isLoading,
        error,
        isItemDisabled,
        handleToggle,
        handleGiftEmailChange,
        handleGiftSaved,
        handleConfirm
    } = useSortingItems();
    const {
        isLoading: isButtonLoading,
        buttonVariant,
        isButtonDisabled,
        buttonText,
        handleProceed
    } = useSortingButton({ selectedItems, sortingItems, handleConfirm });

    useEffect(() => {
        sendEvent({
            event: EventType.PAGE_VIEW,
            event_metadata: {
                page: 'sorting',
                userId: auth.userId,
                userEmail: userData?.email,
            }
        });
    }, [auth.userId, userData?.email]);

    if (isLoading) {
        return (
            <LoadingOverlay />
        );
    }

    return (
        <div className='w-full min-h-screen flex flex-col'>
            {/* Fixed Header */}
            <div className="fixed top-0 left-0 right-0 py-8 flex justify-center items-center bg-white z-10">
                <HolifyaLogoComplete />
            </div>

            {/* Content */}
            <div className="flex-1 w-full overflow-y-auto scrollbar-hide pt-32 pb-[120px] px-5 flex flex-col items-center">
                <div className="w-full mx-auto space-y-sm pb-0 md:w-[500px]">
                    {sortingItems?.map((item, index) => (
                        <SortingItemCard
                            key={item.id}
                            item={item}
                            index={index}
                            isToggled={selectedItems[index]?.isToggled || false}
                            giftEmail={selectedItems[index]?.giftEmail || ''}
                            onToggle={handleToggle}
                            onGiftEmailChange={handleGiftEmailChange}
                            onGiftSaved={handleGiftSaved}
                            dnaTestSelected={Object.values(selectedItems).some(item => item.isToggled)}
                            subSelected={Object.values(selectedItems).some(item => item.isToggled)}
                            disabled={isItemDisabled(item)}
                        />
                    ))}
                </div>
            </div>

            {/* Fixed Footer */}
            <div className="fixed bottom-0 left-0 right-0 py-8 px-5 flex justify-center items-center bg-white z-10">
                <Button
                    size={'form'}
                    variant={buttonVariant}
                    disabled={isButtonDisabled || isButtonLoading}
                    className='w-full md:w-[500px]'
                    onClick={handleProceed}
                >
                    {buttonText}
                </Button>
            </div>

            {warningMessage && (
                <WarningDialog
                    text={warningMessage}
                    onClose={() => setWarningMessage(null)}
                />
            )}
        </div>
    );
};
